import React from "react";
import {Backdrop, Button, Container, TextField} from "@mui/material";
import styled from "styled-components";
import { actions as appActions } from "../../redux/app";
import { useDispatch } from "react-redux";
import { useRouter } from "next/router";
import { media } from "../../../styles/styles";

const StyledBackdrop = styled(Backdrop)`
  &.MuiBackdrop-root {
    z-index: 2000;
    color: #fff;
    background-color: rgba(0, 0, 0, 1);
    font-size: 1.8rem;
    text-align: center;
  }
`;
const StyledTextField = styled(TextField)`
  &.MuiTextField-root {
    font-size: 1.3rem;
    margin: 1em;
    min-width: 46%;
    > * {
      color: #de4a22;
      font-size: 1em;
    }
    .MuiFormHelperText-root {
      font-size: 0.5em;
    }
    .MuiInputLabel-filled {
      transform: translate(12px, 24px) scale(1);
      &.MuiInputLabel-shrink {
        transform: translate(12px, 2px) scale(0.75);
      }
    }
    .MuiInputBase-root {
      background-color: #fff;
      color: #000;

      &:after {
        border-color: #de4a22;
      }
    }
    label {
      color: #de4a22;
    }
    fieldset {
      border-color: #fff;
      &:hover {
        border-color: #de4a22;
      }
    }
  }
`;
const StyledButton = styled(Button)`
  &.MuiButton-root {
    font-size: 1.3rem;
    background-color: #de4a22;
    color: #fff;
    padding: 0.3em 3em;
    &:hover {
      background-color: #fff;
      color: #de4a22;
    }
  }
`;
const StyledTextButton = styled(Button)`
  &.MuiButton-root {
    font-size: 1.3rem;
    color: #de4a22;
    padding: 0.3em 3em;
  }
`;
const FullWidthWrapper = styled.div`
  width: 100%;
`;
const ReducedTextDiv = styled.div`
  ${media.tablet`
  font-size: 1.2rem;
  `};
`;
export default function PipaGate({ open }) {
  const router = useRouter();
  const [text, setText] = React.useState("");
  const [helperText, setHelperText] = React.useState(null);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (text === "YES") {
      setHelperText(null);
      dispatch(appActions.setPipa());
    } else  {
      setHelperText("Please enter 'Yes' if you agree to the above.");
    }
  };
  const handleToggle = () => {
    router.push("/");
  };
  const dispatch = useDispatch();
  return (
    <StyledBackdrop open={open}>
      <FullWidthWrapper>
        <Container maxWidth="md">
          <ReducedTextDiv>
            <p>Our site has information on compensation claims which is restricted under Queensland and Western Australian law.</p>
            <p>To continue, please confirm you are genuinely seeking legal advice by entering ‘yes’ in the field below.</p>
          </ReducedTextDiv>
          <form onSubmit={handleSubmit}>
            <div>
              <StyledTextField
                label="Type here"
                variant="filled"
                value={text}
                onChange={(e) => setText(e.target.value.toLocaleUpperCase())}
                helperText={helperText}
              />
            </div>
            <div>
              <div>
                <StyledButton
                  variant="outlined"
                  color="primary"
                  onClick={handleSubmit}
                >
                  Continue
                </StyledButton>
              </div>
              <div>
                <StyledTextButton
                  variant="text"
                  color="primary"
                  onClick={handleToggle}
                  size="large"
                  type="button"
                >
                  No thanks
                </StyledTextButton>
              </div>
            </div>
          </form>
        </Container>
      </FullWidthWrapper>
    </StyledBackdrop>
  );
}
